import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';
import styled from 'styled-components';

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  min-height: ${props => props.minHeight || '300px'};
`;

const LoadingText = styled.div`
  margin-top: 1rem;
  color: #666666;
  font-size: 0.875rem;
`;

const LoadingSpinner = ({ text, minHeight }) => {
  return (
    <SpinnerContainer minHeight={minHeight}>
      <div style={{ textAlign: 'center' }}>
        <Spinner show />
        {text && <LoadingText>{text}</LoadingText>}
      </div>
    </SpinnerContainer>
  );
};

LoadingSpinner.propTypes = {
  text: PropTypes.string,
  minHeight: PropTypes.string
};

LoadingSpinner.defaultProps = {
  text: 'Loading...',
  minHeight: '300px'
};

export default LoadingSpinner;
